import Helper from "../../../../common/utils/helper";
import BaseComponent from "../../../../common/js/BaseComponent";
import Cart from "../pages/hegyd/hegyd-ecommerce/cart";

export default class SlotTime extends BaseComponent {
    constructor(view: HTMLElement) {
        super(view);
    }

    checkbox = document.getElementById(
        'is-comment-required',
    ) as HTMLInputElement | null;

    getSubmitBtnSelector() {
        return '#submit-CnC';
    }

    getPreviousBtn() {
        return '#CnC-previous';
    }


    getRdvButtonSelector() {
        return '.take-appointment';
    }

    init() {
        this.initCheckedCheckbox();
        this.initForm();
        this.initPrevious();
    }

    initCheckedCheckbox() {
        // SlotTime.actionCheckboxes();
        // var checkboxes = jQuery('input[type="checkbox"]');
        $('.form-selectgroup-input').on('click', function () {
            fetch($(this).data('href'), {
                method: 'GET',
                //  headers: Helper.createFetchHeader(),
            })
                .then((response) => Promise.all([response, response.text()]))
                .then(([, data]) => {
                    const timeDetail = document.querySelector('#slot-time-details');
                    if (timeDetail) {
                        timeDetail.innerHTML = data;
                    }
                });
        });
    }

    initForm() {
        // @ts-ignore
        const form: HTMLFormElement = $(this.view).find('#slot-time-form')[0];
        if (form) {
            document.querySelectorAll(this.getRdvButtonSelector())
                .forEach((takeAppoint) => {
                    takeAppoint.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.updateModalContent(e.target);
                    });
                });

            form.addEventListener('submit', (event) => {
                event.preventDefault();
                const formData = new FormData(form);

                fetch($(form).attr('action') ?? '/', {
                    method: 'POST',
                    body: formData,
                    headers: Helper.createFetchHeaderWithoutContentType(),
                })
                    .then((response) => Promise.all([response, response.json()]))
                    .then(([response, data]) => {
                        if (!response.ok) {
                            throw new Error(data.message ?? '');
                        }
                        // Dans le cas ou l'on a un message
                        if (data.message) {
                            Helper.createToastElement(data.message, 'success');
                        }
                        this.toggleValidCart(data.isCartValid);

                        // On ferme la modale
                        $('#driveStep-1').modal('hide');
                        (window as any).updateCartViews(data);
                    })
                    .catch((error) => {
                        // @TODO
                    });
            });
        }
    }

    toggleValidCart(isValid: boolean) {
        const btns = $('.cart-validate');
        btns.each(function() {

            if($(this).hasClass('disabled') && isValid) {
                $(this).removeClass('disabled');
            }else {
                if (! $(this).hasClass('disabled') && ! isValid) {
                    $(this).addClass('disabled');
                }
            }
        })
    }

    static actionListener() {
        /* display / hide actions button */
        window.addEventListener('scroll', () => {
            if (document.getElementById('home-testimonials') != null) {
                const testimonials = document.getElementById('home-testimonials');
                if (testimonials) {
                    const positionSection = testimonials.getBoundingClientRect();
                    const height = positionSection.height * -1;
                    const actions = document.querySelector('#actions');

                    if (actions) {
                        if ((positionSection.top < 1 && positionSection.top > height)
                            || (positionSection.top < 1 && positionSection.top < height)) {
                            actions.classList.add('d-none');
                            actions.classList.remove('d-flex');
                        } else if (positionSection.top < height || positionSection.top > 1) {
                            actions.classList.add('d-flex');
                            actions.classList.remove('d-none');
                        }
                    }
                }
            }
        });
    }

    updateModalContent(element: HTMLLinkElement, selector: string = '.modal-content'): void {
        fetch(element.getAttribute('href') ?? '/', {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                if (this.view) {
                    const modalContent = this.view.querySelector(selector);
                    if (modalContent) {
                        modalContent.innerHTML = data;
                    }
                }
            });
    }

    static displaySubMenu() {
        const menu = document.querySelector('ul.dropdown-menu');
        if (menu) {
            menu.classList.add('show');
        }

        const firstLink = document.querySelector('#dropdownMenuLink');
        if (firstLink) {
            firstLink.classList.add('show');
        }
    }

    initPrevious() {
        const prev = document.querySelector(this.getPreviousBtn());
        if(prev) {
            prev.addEventListener('click', (e) => {
                e.preventDefault();
                this.updateModalContent(e.target);
            });
        }
    }
}
